import { ScrollArea, Text } from '@radix-ui/themes';
import clsx from 'clsx';
import ApplicationSummary from 'components/Applications/ApplicationSummary';
import ApplicationAccepted from 'components/Applications/components/ApplicationAccepted';
import ApplicationQualified from 'components/Applications/components/ApplicationQualified';
import ApplicationStage from 'components/Applications/components/ApplicationStage';
import ApplicationStatus from 'components/Applications/components/ApplicationStatus';
import MutedText from 'components/common/MutedText';
import HubertTabs from 'components/HubertUI/HubertTabs';
import type { ComponentProps } from 'react';
import type { TExtendedApplication } from 'types/application.types';

interface Props extends ComponentProps<'div'> {
  jobId: string | undefined;
  applicationId: string | undefined;
  currentRow: TExtendedApplication | undefined;
}

const tabs = [
  { name: 'Summary', value: 'summary' },
  { name: 'Interview', value: 'interview' },
  { name: 'Communications', value: 'communications' },
  { name: 'Activity Log', value: 'activity-log' },
];
const defaultTab = 'summary';

const JobApplication = ({ jobId, applicationId, currentRow, ...props }: Props) => {
  if (!jobId || !applicationId || !currentRow) return null;

  return (
    <div className="grid grid-cols-3 gap-4">
      <ScrollArea type="hover" className={clsx('max-h-[calc(100vh-224px)]', 'h-full w-full', 'col-span-1')}>
        <div className={clsx('flex flex-col justify-between gap-4')}>
          <div className={clsx('flex flex-col text-center', 'p-8')}>
            <Text size={'6'}>
              {currentRow.candidate.first_name} {currentRow.candidate.last_name}
            </Text>
            <MutedText>{currentRow.candidate.email}</MutedText>
          </div>

          <ApplicationAccepted accepted={currentRow.accepted} />
          <ApplicationQualified qualified={currentRow.qualified} />

          <ApplicationStage stage={currentRow.stage} />
          <ApplicationStatus status={currentRow.status} />
          {/* <ApplicationScore score={currentRow.score} /> */}
          <div>{jobId}</div>
          <div>{applicationId}</div>
          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((x) => {
            return (
              <div key={x} className="py-12">
                {x}
              </div>
            );
          })}
        </div>
      </ScrollArea>

      <HubertTabs
        /* @ts-ignore */
        direction="vertical"
        {...props}
        defaultValue={defaultTab}
        className={clsx('col-span-2', 'h-full w-full')}
      >
        <HubertTabs.List>
          {tabs.map((tab, tabIndex: number) => {
            return (
              <HubertTabs.Trigger key={tabIndex} value={tab.value}>
                {tab.name}
              </HubertTabs.Trigger>
            );
          })}
        </HubertTabs.List>

        {tabs.map((tab, tabIndex: number) => {
          return (
            <HubertTabs.Content key={tabIndex} value={tab.value} className={clsx('h-full w-full')}>
              {(() => {
                if (tab.value === 'summary') {
                  return <ApplicationSummary applicationId={applicationId} />;
                }

                if (tab.value === 'interview') {
                  return <div>Interview</div>;
                }

                if (tab.value === 'communications') {
                  return <div>communications</div>;
                }

                if (tab.value === 'activity-log') {
                  return <div>activity-log</div>;
                }
              })()}
            </HubertTabs.Content>
          );
        })}
      </HubertTabs>
    </div>
  );
};

export default JobApplication;

/**
    <ScrollArea
      type='hover'
      className={clsx(
        'max-h-[calc(100vh-224px)]',
        'h-full w-full',
        // 'bg-success-50',
      )}
    >
      <div
        className={clsx(
          'flex flex-col justify-between gap-4'
        )}
      >
        <ApplicationSummary applicationId={applicationId} />
      </div>
    </ScrollArea>
 */
